import dayjs from 'dayjs';

import { utcDTStr2UTC } from 'utils/dateTime';

export default function getPrizeRedeemWithinEndUtc(startDateTime, withinDays) {
    const startDateUTC = utcDTStr2UTC(startDateTime);
    const endDateUTC = dayjs(startDateUTC)
        .add(withinDays, 'day')
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(999)
        .valueOf();
    return endDateUTC;
}

export function getPrizeRedeemWithinMonthEndUtc(startDateTime, withinMonths) {
    // 計算幾個月後月底日期
    const startDateUTC = utcDTStr2UTC(startDateTime);
    const endDateUTC = dayjs(startDateUTC)
        .add(withinMonths, 'month')
        .hour(23)
        .minute(59)
        .second(59)
        .millisecond(999)
        .endOf('month')
        .valueOf();
    return endDateUTC;
}
